<template>
  <div
    class="limit-width"
    :class="bem('limit-width', { responsive })"
    :style="style"
  >
    <slot></slot>
  </div>
</template>

<script>
  import { bem } from 'src/utils/bem.js';

  export default {
    name: 'LimitWidth',
    props: {
      max: [String, Number],
      responsive: {
        type: Boolean,
        default: true,
      }
    },
    methods: {
      bem,
    },
    computed: {
      style() {
        const { max } = this;
        return {
          '--limit-width--max': `${max}px`
        }
      }
    },
  }
</script>